const entry = {
  secure: '企业空间已安全识别',
  title: '从企业真值开始，而不是重填一遍。',
  body: '领航者已经识别出这个邀请身份下的企业项目。继续上次项目，或为新的市场目标开始一次诊断。',
  identity: '当前邀请身份',
  changeEmail: '切换登录邮箱',
  signingOut: '正在退出…',
  signOutFailed: '暂时无法退出，请检查网络后重试。',
  existingTitle: '回到你的项目',
  existingBody: '默认选中上次使用的项目',
  projectCount: '{count} 个项目',
  ready: '已就绪',
  continueSetup: '继续完成项目',
  targetMarkets: '目标市场',
  lastOpened: '最近进入',
  noMarkets: '暂未设置',
  viewProjects: '查看已有项目',
  startDiagnosis: '开始新诊断',
  serverTruth: '项目列表来自服务器；本机只记住上次选择。',
  emptyTitle: '建立第一个项目',
  emptyHint: '这个邀请身份下还没有企业项目',
  emptyLead: '四步完成企业接入',
  emptyBody: '填写企业与产品信息、选择目标市场、添加公开链接和项目资料，然后确认诊断范围。',
  emptyNote: '资料未确认前可保存并退出。',
}

export default entry
